
export default class BaseChartModel {
    constructor(dataRecords, parent, options) {
        this.rawDataRecords = dataRecords;
        this.parent = parent;
        this.options = options;
    }

    get id() {
        return this.options.id;
    }

    get chartType() {
        // return (this.options.chartType === 'rankedBar') ? 'regionCompareDotPlot' : this.options.chartType;
        return (this.parent.showPDF && this.options.chartType === 'rankedBar') ? 'regionCompareDotPlot' : this.options.chartType;
    }

    get label() {
        return this.options.label;
    }

    get pdfLabel() {
        return this.options.pdfLabel;
    }

    get shortLabel() {
        return this.options.shortLabel;
    }

    get pdfDescription() {
        return this.options.pdfDescription;
    }

    get definition() {
        return this.options.definition;
    }

    get linkToHealth() {
        return this.options.linkToHealth;
    }

    get dataSource() {
        return `${this.options.year} ${this.options.dataSource}`;
    }

    get format() {
        return value => (value == null ? 'N/A' : this.options.format(value));
    }

    get formatWithUnits() {
        return value => (value == null ? 'N/A' : `${this.options.format(value)}${this.options.units}`);
    }

    get valueLabel() {
        const label = this.valueLabelFull;
        if (this.parent.showPDF && this.valueLabelFull.length >= 30) {
            return `${label.substring(0, 27)}...`;
        }
        return label;
    }

    get valueLabelFull() {
        if (this.options.showZoneData) {
            return 'Zone';
        }
        const label = this.parent.localName;
        return `${label} LGA`;
    }

    get comparisonLabel() {
        if (this.options.showZoneData) {
            return 'AB';
        }
        return this.parent.comparison;
    }

    get valueGeographyCode() {
        if (this.options.showZoneData) {
            return this.parent.geographyCode.split('.')[0];
        }
        return this.parent.geographyCode;
    }

    get comparisonGeographyCode() {
        if (this.options.showZoneData) {
            return 'AB';
        }
        return this.parent.comparisonGeographyCode;
    }
}
